var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Regresaremos pronto!")]),_c('p',[_vm._v("La aplicación se encuentra en mantenimiento programado. Por favor regresa más tarde.")]),_c('p',[_vm._v("Horario de mantenimiento: Viernes 14 de agosto de 2026 hasta las 16:00 hrs.")])])])
}]

export { render, staticRenderFns }